export default "Régions, métropoles et EPCI proposent des subventions complémentaires aux aides nationales pour la rénovation des copropriétés. Identifiez les aides disponibles dans votre territoire.";
